
import URL_SCHEME from 'modules/api/constants';
import APIRequest from 'modules/api/APIRequest';

import AccountRequest from 'modules/api/accountRequest';
import NoteRequest from 'modules/api/noteRequest';
import DataRequest from 'modules/api/dataRequest';
import FamilyRequest from 'modules/api/familyRequest';
import GroupRequest from 'modules/api/groupRequest';
import SettingsRequest from 'modules/api/settingsRequest';
import NotificationRequest from 'modules/api/notificationRequest';
import DeviceRequest from 'modules/api/deviceRequest';

const RequestInstance = new APIRequest(URL_SCHEME);

export default {
  noteRequest: new NoteRequest(RequestInstance),
  dataRequest: new DataRequest(RequestInstance),
  familyRequest: new FamilyRequest(RequestInstance),
  groupRequest: new GroupRequest(RequestInstance),
  settingsRequest: new SettingsRequest(RequestInstance),
  accountRequest: new AccountRequest(RequestInstance),
  notificationRequest: new NotificationRequest(RequestInstance),
  deviceRequest: new DeviceRequest(RequestInstance),
};
